<template>
  <div>
    <WorkRights :value="profile.workRights" v-if="active" autofocus />

    <v-btn block
      :color="themes.candidate.light.primaryActionButton"
      @click="$emit('input')"
      :disabled="disabled"
    >
      Save
    </v-btn>
  </div>
</template>

<script>
// Components
import WorkRights from '@/components/candidate/profile/edit/details/WorkRights'

// Helpers
import _ from 'lodash'

export default {
  components: { WorkRights },

  created() {
    if (!_.get(this, 'profile.workRights')) {
      this.$store.dispatch('candidate/profile/fetch')
    }
  },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
  computed: {
    disabled() {
      return !_.get(this, 'profile.workRights[0]')
    },
  },
}
</script>
